export default __webpack_public_path__ + "img/landscape_1.bc2540c777c5770e053c893d738fe269.jpg";